export class NavBar {
    navBarElement: HTMLElement | null = document.querySelector('.js-nav-bar');

    constructor() {
        if (!this.navBarElement) {
            return;
        }

        window.addEventListener('scroll', () => {
            if (window.scrollY > 40) {
                document.body.classList.add('page-scrolled');
            } else {
                document.body.classList.remove('page-scrolled');
            }
        })
    }
}